export {default} from './GeneralInformationsCard.container';
